
import angular from 'angular';
import adminModule from "../admin.module"

adminModule.controller('CredentialMappingController', function($scope) {
  console.log('initialized the credential mapping controller')

  let vm = this

  vm.isEditable = false // because we don't support that yet....

  // What determines the editability?  if it's an api vs manual  provider
  // should this come back in some kind of payload from the server?
  // sure

  // Fetch list of: mapped locations, including editability
  // if editable, fetch full list of groups/locations for editing





})
